export default "__VITE_ASSET__15a483d3__"